module.exports = __webpack_public_path__ + "static/media/assist-img-1.42fab558.png";